import { render } from "./BillingPayments.vue?vue&type=template&id=3d352344&scoped=true"
import script from "./BillingPayments.vue?vue&type=script&lang=js"
export * from "./BillingPayments.vue?vue&type=script&lang=js"

import "./BillingPayments.vue?vue&type=style&index=0&id=3d352344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d352344"]])

export default __exports__